export class RelationshipDiagram {
    public title: String;
    public entityType: String;
    public metadata: Map<String, String> = new Map<String, String>();
    public children: RelationshipDiagram[] = [];
    public parents: RelationshipDiagram[] = [];

    public getTitle(): String {
        return this.title;
    }

    public getEntityType(): String {
        return this.entityType;
    }

    public getMetadata(): Map<String, String> {
        return this.metadata;
    }

    public getChildren(): RelationshipDiagram[] {
        return this.children;
    }

    public getParents(): RelationshipDiagram[] {
        return this.parents;
    }

}


// WEBPACK FOOTER //
// ./src/app/entities/relations/relationship/relationship-diagram/relationship-diagram.model.ts